/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayCycle } from './PayCycle';
import {
    PayCycleFromJSON,
    PayCycleFromJSONTyped,
    PayCycleToJSON,
    PayCycleToJSONTyped,
} from './PayCycle';

/**
 * 
 * @export
 * @interface CreatePayCycleResponse
 */
export interface CreatePayCycleResponse {
    /**
     * 
     * @type {PayCycle}
     * @memberof CreatePayCycleResponse
     */
    data: PayCycle;
}

/**
 * Check if a given object implements the CreatePayCycleResponse interface.
 */
export function instanceOfCreatePayCycleResponse(value: object): value is CreatePayCycleResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreatePayCycleResponseFromJSON(json: any): CreatePayCycleResponse {
    return CreatePayCycleResponseFromJSONTyped(json, false);
}

export function CreatePayCycleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePayCycleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PayCycleFromJSON(json['data']),
    };
}

  export function CreatePayCycleResponseToJSON(json: any): CreatePayCycleResponse {
      return CreatePayCycleResponseToJSONTyped(json, false);
  }

  export function CreatePayCycleResponseToJSONTyped(value?: CreatePayCycleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayCycleToJSON(value['data']),
    };
}

